/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { IoMdCloseCircle } from 'react-icons/io';
import { toast } from 'react-toastify';

import {
  Container,
  Loader,
  Table,
  Tbody,
  InfoRest,
  Pagination,
  ModalTitle,
  ModalContent,
  ModalContainer,
  ModalStyle,
} from './styles';

import api from '~/services/apiBearer';

import { store } from '~/store';
import { GetReservationFundsRequest } from '~/store/modules/properties/actions';

export default function ReservationFund(props) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(
    useSelector(state => state.properties.loading)
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);
  let subtitle;

  const [reservationFunds, setReservationFunds] = useState(
    store.getState().properties.data.data
  );

  const [address, setAddress] = useState('');
  const [contractId, setContractId] = useState(0);
  const [reference, setReference] = useState('');
  const [topic, setTopic] = useState('');

  const [page, setPage] = useState(1);
  const [totalPages] = useState(10);
  const [showNextPageButton, setShowNextPageButton] = useState(true);

  useEffect(() => {
    const { sAddress, sContractId, sReference, sTopic } = props.location.state;
    setAddress(sAddress);
    setContractId(sContractId);
    setReference(sReference);
    setTopic(sTopic);
  }, [props, reference]);

  useEffect(() => {
    const { token } = store.getState().auth;

    if (contractId > 0)
      dispatch(GetReservationFundsRequest(token, contractId, page, totalPages));
  }, [contractId, dispatch, page, totalPages]);

  useEffect(() => {
    setLoader(true);

    if (contractId === 0) return;

    const url = `api/v1/WSFundoReserva?Contrato=${contractId}&pagina=${page}&tamanhoPagina=${totalPages}`;
    api
      .get(url)
      .then(
        response => {
          const { sucesso: success, conteudo } = response.data;

          if (success) {
            setReservationFunds(conteudo);

            if (conteudo.length < 10) setShowNextPageButton(false);
            else setShowNextPageButton(true);
          }
        },
        error => {
          toast.error('Erro interno, por favor tente novamente mais tarde.');
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }, [contractId, page, totalPages]);

  function openModal() { 
    setModalIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#1c2156';
  }
  function closeModal() {
    setModalIsOpen(false);
  }

  function handleOpenMovieDesk() {
    let codigoFranquia = store.getState().properties.properties.properties[0].codigoFranquia;
    let codigosFranquias = [11, 12, 13, 14, 351, 301, 302, 347];

    if (codigosFranquias.includes(codigoFranquia)) {
      window.open('https://crm.ops.digital/formulario');
    }
    else{
      window.open('https://crm.ops.digital/formulario?client=true');
    }
  }

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />
      <div className="header">
        <h1>{topic}</h1>

        <div>
          <span>Ref.: {reference}</span>
          <span>Contrato: {contractId}</span>
          <span>{address}</span>
        </div>
      </div>
      {reservationFunds && reservationFunds.length ? (
        <Table>
          <thead>
            <tr>
              <td>Data de solicitação do Reembolso</td>
              <td>Valor da restituição</td>
              <td>Previsão da restituição</td>
              <td>Situação</td>
            </tr>
          </thead>
          {reservationFunds && reservationFunds.length ? (
            reservationFunds.map(funds => {
              const creditado = funds.situacao === 'Creditado';
              return (
                <Tbody statusColor={creditado ? '#66CC00' : '#CC0000'}>
                  <tr>
                    <td>
                      {funds.dataVencimento
                        ? format(
                            new Date(funds.dataVencimento),
                            'dd/MM/yyyy'
                          ).toString()
                        : funds.dataVencimento}
                    </td>
                    <td>R$ {funds.valorLancamento}</td>
                    <td>
                      {funds.previsaoLancamento
                        ? format(
                            new Date(funds.previsaoLancamento),
                            'dd/MM/yyyy'
                          ).toString()
                        : funds.previsaoLancamento}
                    </td>
                    <td className="status">{funds.situacao}</td>
                  </tr>
                </Tbody>
              );
            })
          ) : (
            <h2>Contrato não tem fundo de reserva.</h2>
          )}
        </Table>
      ) : (
        <h2>Contrato não tem fundo de reserva.</h2>
      )}

      {reservationFunds && reservationFunds.length ? (
        <Pagination>
          <div>
            {page > 1 ? (
              <FaArrowAltCircleLeft
                size={22}
                onClick={() => setPage(page - 1)}
              />
            ) : (
              <FaArrowAltCircleLeft
                size={22}
                color="#bbb"
                style={{ cursor: 'initial' }}
              />
            )}
            {`Visualizando página ${page}`}
            {showNextPageButton ? (
              <FaArrowAltCircleRight
                size={22}
                onClick={() => setPage(page + 1)}
              />
            ) : (
              <FaArrowAltCircleRight
                size={22}
                color="#bbb"
                style={{ cursor: 'initial' }}
              />
            )}
          </div>
        </Pagination>
      ) : (
        ''
      )}
      <InfoRest>
        O fundo de reserva, como o próprio nome indica, é um fundo diferenciado
        ao caixa do condomínio e sua finalidade é garantir que em meio a uma
        circunstância eventual e emergencial, o condomínio honrará com o
        pagamento de despesas imprevistas, ordinárias ou extraordinárias. <br />
        Você como inquilino, pode pedir restituição. Basta encaminhar o primeiro
        boleto de condomínio pago, com o comprovante de pagamento para
        programarmos a devolução para todo o período do contrato. Se tiver
        alguma alteração de valores ou acréscimo de taxa, deverá nos encaminhar
        boleto e comprovante novamente, para ajustarmos o valor programado de
        reembolso. Na renovação do seu contrato o envio de boleto e comprovante
        deverá ser feito novamente para atualização dos valores e nova
        programação.
      </InfoRest>
      {reservationFunds && reservationFunds.length ? (
        <InfoRest>
          <h3>Fundo de reserva</h3>
          <p>
            Para encaminhar seu comprovante de pagamento e solicitar a
            restituição dos valores de fundo de reserva,{' '}
            <button type="button" onClick={openModal}>
              clique aqui
            </button>{' '}
            e preencha os campos solicitados.
          </p>
        </InfoRest>
      ) : (
        ''
      )}
      <ModalStyle
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
      >
        <ModalContainer>
          <ModalTitle>
            <h2
              ref={_subtitle => {
                // eslint-disable-next-line no-return-assign
                return (subtitle = _subtitle);
              }}
            >
              Quer mesmo falar desse imóvel?
            </h2>
            <IoMdCloseCircle size={20} onClick={closeModal} />
          </ModalTitle>
          <ModalContent>
            <div>
              Anote o n° de referência ou o n° do contrato para identificar o
              imóvel no formulário a seguir.
            </div>
            <strong>n° de referência: {reference}</strong>
            <strong>n° de contrato: {contractId}</strong>
            <button type="button" onClick={() => handleOpenMovieDesk()}>
              Abrir Formulário
            </button>
          </ModalContent>
        </ModalContainer>
      </ModalStyle>
    </Container>
  );
}

ReservationFund.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
